module.exports = __webpack_public_path__ + "assets/img/ts.27741b89.png";